import React, { useState } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import IconButton from '@material-ui/core/IconButton';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ClearIcon from '@material-ui/icons/Clear';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import SplitModalUsageItem from './form/SplitModalUsageItem';
import NewUsageItem from './form/NewUsageItem';
import Modal from '../../shared/modal/Modal';
import ColorButton from '../../shared/ColorButton';

import { caseUsageTypes } from '../../../constants/enums';

import './modal.scss';

const StyledMenuItem = withStyles(() => ({
  root: {
    paddingTop: '4px',
    paddingBottom: '4px',
  },
}))(MenuItem);

const SplitViewModal = (props) => {
  const {
    onClose,
    open,
    inventory = [],
    images = [],
    onApproveClick,
    onAddUsage,
    onUpdateUsage,
    onDelete,
    tenantColor,
    orderClosed,
    users = [],
    tags = [],
    onAddShippedClick,
    onAddMasterClick,
    onAddManualClick,
  } = props;

  const [activeTab, setActiveTab] = useState(0);
  const [addState, toggleAddState] = useState(false);
  const [rotation, setRotation] = useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const rotateClockwise = () => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const onSubmit = (formObj) => {
    if (formObj.quantity && (formObj.ref || formObj.lot || formObj.gtin)) {
      onAddUsage(caseUsageTypes.implants, formObj);
      toggleAddState(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size='lg'
      fullWidth
    >
      <div className='split-view-modal__container'>
        <div className='split-view-modal__content'>
          <div>
            {images && images?.length ? (
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform }) => (
                  <>
                    <div className='split-view-modal__tools'>
                      <IconButton onClick={zoomIn} size='small'>
                        <ZoomInIcon style={{ color: 'var(--app-text)' }} />
                      </IconButton>
                      <IconButton onClick={zoomOut} size='small'>
                        <ZoomOutIcon style={{ color: 'var(--app-text)' }} />
                      </IconButton>
                      <IconButton onClick={resetTransform} size='small'>
                        <ClearIcon style={{ color: 'var(--app-text)' }} />
                      </IconButton>
                      <IconButton onClick={rotateClockwise} size='small'>
                        <RotateRightIcon style={{ color: 'var(--app-text)' }} />
                      </IconButton>
                    </div>
                    <TransformComponent>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '100%',
                          height: '100%',
                          overflow: 'visible',
                        }}
                      >
                        <img
                          src={images[activeTab]?.image?.downloadUrl}
                          alt='usage'
                          style={{
                            transform: `rotate(${rotation}deg)`,
                            transition: 'transform 0.3s ease-in-out',
                            // maxWidth: '100%',
                            // maxHeight: '100%',
                          }}
                        />
                      </div>

                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            ) : (
              <div className='font-bold secondary' style={{ fontSize: 32 }}>
                Image preview here
              </div>
            )}
          </div>
          <div className='split-view-modal__inventory'>
            {addState ? (
              <NewUsageItem
                onSubmit={onSubmit}
              />
            ) : (
              inventory?.map((item) => (
                <SplitModalUsageItem
                  key={item.id}
                  item={item}
                  onApproveClick={onApproveClick}
                  onSave={onUpdateUsage}
                  onDelete={onDelete}
                  orderClosed={orderClosed}
                  tenantColor={tenantColor}
                  users={users}
                  tags={tags}
                />
              ))
            )}
          </div>
        </div>
        <div className='split-view-modal__actions'>
          <div className='d-flex'>
            {images?.map((image, index) => (
              <div key={`Image_${Math.random()}`} className='m-r-lg'>
                <ColorButton
                  color={activeTab === index ? 'blue' : 'grey'}
                  onClick={() => setActiveTab(index)}
                  text={`Image ${index + 1}`}
                  height={30}
                />
              </div>
            ))}
          </div>
          <div>
            {!orderClosed ? (
              addState ? (
                <ColorButton
                  color='blue'
                  onClick={() => toggleAddState(!addState)}
                  text='Back'
                  height={30}
                />
              ) : (
                <>
                  <ColorButton
                    color='blue'
                    onClick={handleClick}
                    text='Add'
                    height={30}
                  />
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={isOpen}
                    onClose={handleClose}
                    PaperProps={{
                      elevation: 3,
                    }}
                  >
                    <StyledMenuItem
                      onClick={() => {
                        onAddShippedClick();
                        handleClose();
                      }}
                    >
                      <span>Shipped Equipment</span>
                    </StyledMenuItem>
                    <StyledMenuItem
                      onClick={() => {
                        onAddMasterClick();
                        handleClose();
                      }}
                    >
                      <span>Item Master</span>
                    </StyledMenuItem>
                    <StyledMenuItem
                      onClick={() => {
                        onAddManualClick();
                        handleClose();
                      }}
                    >
                      <span>Manual Type</span>
                    </StyledMenuItem>
                  </Menu>
                </>
              )
            ) : (
              <div />
            )}
            <ColorButton
              color='blue'
              text='Close'
              onClick={onClose}
              height={30}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SplitViewModal;
